import {
  Control,
  Controller,
  FieldErrors,
  UseFormTrigger,
} from 'react-hook-form';
import { emailRegex } from '../../../utils/regular-expressions';
import { HubSpotContact } from '../../../api/billing-types';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

interface HubspotContactInfoFormProps {
  control: Control<Partial<HubSpotContact>>;
  errors: FieldErrors<Partial<HubSpotContact>>;
  trigger: UseFormTrigger<Partial<HubSpotContact>>;
}

export default function HubspotContactInfoForm({
  control,
  errors,
  trigger,
}: HubspotContactInfoFormProps) {
  return (
    <Grid container spacing={2}>
      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <Controller
          name={'properties.email'}
          control={control}
          rules={{
            required: `Please provide an email address.`,
            pattern: {
              value: emailRegex,
              message: 'Please provide a valid email address.',
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Email address"
              required
              autoComplete="email"
              error={!!errors.properties?.email}
              helperText={
                errors.properties?.email ? errors.properties.email.message : ' '
              }
              slotProps={{
                formHelperText: {
                  sx: { textWrap: 'nowrap' },
                },
              }}
              onChange={(event) => {
                field.onChange(event.target.value);
                trigger('properties.email');
              }}
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <Controller
          name={'properties.firstName'}
          control={control}
          rules={{
            required: `Please provide a first name.`,
          }}
          render={({ field }) => (
            <TextField
              {...field}
              onBlur={() => {
                trigger('properties.firstName');
              }}
              label="First Name"
              fullWidth
              required
              autoComplete="given-name"
              error={!!errors.properties?.firstName}
              helperText={
                errors.properties?.firstName
                  ? errors.properties.firstName.message
                  : ' '
              }
            />
          )}
        />
      </Grid>

      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <Controller
          name={'properties.lastName'}
          control={control}
          rules={{
            required: `Please provide a last name.`,
          }}
          render={({ field }) => (
            <TextField
              {...field}
              onBlur={() => {
                trigger('properties.lastName');
              }}
              label="Last Name"
              fullWidth
              required
              autoComplete="family-name"
              error={!!errors.properties?.lastName}
              helperText={
                errors.properties?.lastName
                  ? errors.properties.lastName.message
                  : ' '
              }
            />
          )}
        />
      </Grid>
      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <Controller
          name={'properties.phone'}
          control={control}
          rules={{
            required: `Please provide a phone number.`,
          }}
          render={({ field }) => (
            <TextField
              {...field}
              onBlur={() => {
                trigger('properties.phone');
              }}
              label="Phone Number"
              fullWidth
              required
              autoComplete="tel"
              error={!!errors.properties?.phone}
              helperText={
                errors.properties?.phone ? errors.properties.phone.message : ' '
              }
            />
          )}
        />
      </Grid>
    </Grid>
  );
}
